<template>
  <a-modal
    :footer="null"
    :width="600"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :maskClosable="false"
    :title="
      isSpare
        ? $t('single_status.modal_title_spare')
        : $t('single_status.modal_title')
    "
    class="j-modal-box-shadow"
    :maskStyle="{ 'background-color': 'inherit' }"
  >
    <div>
      <a-form
        ref="form"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item
          name="quantity"
          :label="$t('single_status.quantity')"
          :wrapperCol="{ span: 12 }"
          :rules="[
            {
              type: 'string',
              required: true,
              message: $t('single_status.quantity_msg')
            },
            validateQuantity()
          ]"
        >
          <a-input
            @change="handleQuantityChange"
            type="number"
            v-model:value="form.quantity"
          >
            <template #addonBefore>
              <MinusOutlined class="btn-icon" @click="substract" />
            </template>
            <template #addonAfter>
              <PlusOutlined class="btn-icon" @click="add" />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item name="remark" :label="$t('single_status.remark')">
          <a-textarea v-model:value="form.remark" :rows="4" />
        </a-form-item>

        <div style="text-align: right;">
          <a-button
            :loading="loading"
            @click="handleCancel"
            class="j-outline-btn1 j-height-auto"
          >
            {{ $t('single_status.cancel') }}
          </a-button>
          <a-button
            :loading="loading"
            @click="handleConfirm"
            type="primary"
            class="j-height-auto"
            style="margin-left: 10px;"
          >
            {{ $t('single_status.confirm') }}
          </a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import numeral from 'numeral';
import { message } from 'ant-design-vue';
import { mapState } from 'vuex';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { addToCart } from '@/api/apis';
import { validateQuantity } from '@/utils/validate';

export default defineComponent({
  name: 'SingleStatusModal',
  emits: ['after-close'],
  props: {
    record: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    isSpare: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: Number,
      default: null
    },
    vehicleId: {
      type: Number,
      default: null
    }
  },
  components: {
    MinusOutlined,
    PlusOutlined
  },
  data() {
    return {
      validateQuantity,
      visible: true,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        quantity: '1',
        remark: ''
      },
      isAddedToCart: false
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    handleAfterClose() {
      this.$emit('after-close', this.isAddedToCart);
    },
    handleQuantityChange() {
      const quantity = +this.form.quantity;
      if (quantity > 9999) {
        this.form.quantity = '9999';
      }

      if (quantity === 0) {
        this.form.quantity = '1';
      }
    },
    substract() {
      const quantity = Number(this.form.quantity);
      if (!isNaN(quantity) && quantity > 1) {
        this.form = {
          ...this.form,
          quantity: String(quantity - 1)
        } as any;

        const form = (this.$refs as any).form;

        form.clearValidate('quantity');
      }
    },
    add() {
      const quantity = Number(this.form.quantity || 0);
      if (quantity < 9999) {
        this.form = {
          ...this.form,
          quantity: String(quantity + 1)
        } as any;
        const form = (this.$refs as any).form;
        form.clearValidate('quantity');
      }
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addToCart({
            ...this.form,
            quantity: numeral(this.form.quantity).value(),
            customerId: this.userInfo.id,
            modelNum: this.record.modelNum,
            name: this.record.partName,
            partCode: this.record.partCode,
            groupName: this.record.groupName,
            unit: this.record.unit,
            unitPrice: this.record.sellingPrice,
            consignee: this.userInfo.companyName,
            shoppingType: 2,
            groupId: this.groupId,
            vehicleId: this.vehicleId,

            partsId: this.record.id
          });
          if (res.success) {
            this.isAddedToCart = true;
            this.handleCancel();

            message.success(this.$t(res.message));
          }

          this.loading = false;
        })
        .catch();
    }
  }
});
</script>

<style lang="scss" scoped></style>
